module.exports = __webpack_public_path__ + "static/media/drap-d.778b22a5.mp3";